import React from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import PageBlock from '@sharedCR/common/PageBlock';
import DataDisplay, {
  useResponsiveDataDisplayVariant,
} from '@sharedCR/coreDesignSystem/DataDisplay';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { checkIsHelocLoanType } from 'utils/loanApplication';

import {
  selectCommonInfoLoanApplication,
  selectServicingSummary,
} from 'store/loanApplications/selectors';

import { getSummaryInfoConfig } from './ServicingSummary.config';
import {
  pageBlockClasses,
  summaryCardStyles,
  summaryWrapperStyles,
} from './ServicingSummary.styles';

const SUMMARY_SKELETONS_LENGTH = 8;

const ServicingSummary = ({ isLoading, hasEscrow = false }) => {
  const summary = useSelector(selectServicingSummary);
  const { loanType } = useSelector(selectCommonInfoLoanApplication);
  const isHeloc = checkIsHelocLoanType(loanType);

  const summaryInfo = getSummaryInfoConfig(summary, { isHeloc, hasEscrow });

  const dataDisplayVariant = useResponsiveDataDisplayVariant();

  return (
    <PageBlock classes={pageBlockClasses} title="Servicing Summary">
      <Box sx={summaryWrapperStyles}>
        {isLoading
          ? Array.from({ length: SUMMARY_SKELETONS_LENGTH }, (_, index) => (
              <Box key={index} sx={summaryCardStyles}>
                <DataDisplay isLoading title="" value="" variant={dataDisplayVariant} />
              </Box>
            ))
          : summaryInfo.map(({ name, value, icon, iconColor }) => (
              <Box key={name} sx={summaryCardStyles}>
                <DataDisplay
                  icon={icon}
                  iconColor={iconColor}
                  title={name}
                  value={value}
                  variant={dataDisplayVariant}
                />
              </Box>
            ))}
      </Box>
    </PageBlock>
  );
};

ServicingSummary.propTypes = {
  hasEscrow: PropTypes.bool,
  ...WithLoadingPropTypes,
};

export default ServicingSummary;
